import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import {validateTagName} from '../../../../services/validations/validateTagName';
import withClickOutsideOnOverlay from '../../../../hoc/withClickOutsideOnOverlay';
import formats from '../../../../const/formats';
import moment from 'moment';
import ReactTooltip from 'react-tooltip';
import FilterSwitcher from '../../../components/FilterSwitcher/FilterSwitcher';
import tooltipService from '../../../../services/tooltipService';
import { getNextTagName } from '../../../../services/mini/getNextTagName';
import {FormWithCancelButton} from '../../../forms/FormWithCancelButton';
import ValidationForm from '../../../forms/ValidationForm';
import PopupHeader from '../../../components/Popup/PopupHeader';
import PopupWrapper from '../../../components/Popup/PopupWrapper';
import PopupBody from '../../../components/Popup/PopupBody';
import PopupButtons from '../../../components/Popup/PopupButtons';
import { okButtonClass, cancelButtonClass } from '../../../../const/popupButtonClasses';
import device from '../../../../services/mini/device';
import { isLastTag } from '../../../../services/mini/isLastTag';
import { isCiCdTag } from '../../../../services/mini/isCiCdTag';

class NewProjectTagForm extends FormWithCancelButton {
    constructor(props, context) {
        super(props, context);

        this.state = {
            runVersionOnProductionFlag: false,
            runVersionOnTestingFlag: false,
            showTooltip: false
        };
    }

    componentDidMount() {
        this._isMounted = true;
        this.manageTooltip();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    getNextTagName() {
      const { project } = this.props;
      return getNextTagName(project);
  }

    manageTooltip() {
        const tooltip = ReactDOM.findDOMNode(this.refs.runCopiedVersionOnProdTooltip);
        if (tooltipService.shouldShowRunCopiedVersionOnProdTooltip()) {
          this.setState({ showTooltip: true });
            setTimeout(() => {
                ReactTooltip.rebuild();
                ReactTooltip.show(tooltip);
            }, 300);
        } else {
            this.setState({ showTooltip: false });
            ReactTooltip.hide(tooltip);
        }
    }

    rememberTooltipChoice = () => {
        const tooltip = ReactDOM.findDOMNode(this.refs.runCopiedVersionOnProdTooltip);
        tooltipService.saveRunCopiedVersionOnProdTooltipState();
        this.setState({ showTooltip: false });
        ReactTooltip.hide(tooltip);
    }

    validateTagName = ({ tagName }) => {
      return validateTagName(tagName, this.props.project);
    }
  
    ok = ({ tagName }) => {
        const { project, environment, createProjectTag, onClose } = this.props;
        const runVersionOnProd = this.state.runVersionOnProductionFlag;
        const runVersionOnTesting = this.state.runVersionOnTestingFlag;
        createProjectTag({
            project,
            tagName,
            environment,
            runVersionOnProd,
            runVersionOnTesting
        }).then(() => {
            if (this._isMounted) {
                onClose();
            }
        });
    }

    onRunVersionOnProductionChange = () => {
        this.setState({ runVersionOnProductionFlag: !this.state.runVersionOnProductionFlag });
    }

    onRunVersionOnTestingChange = () => {
        this.setState({ runVersionOnTestingFlag: !this.state.runVersionOnTestingFlag });
    }

    render() {
        const { project, tier } = this.props;
        const { showTooltip } = this.state;
        const previousVersions = project.tags.filter((tag) => {
            return !isLastTag(tag) && !isCiCdTag(tag);
        });
        //todo: recheck form
        return (
          <PopupWrapper className="new-project-tag-form">
            <PopupHeader title="Save as New Version" onCancel={this.cancel} />
            <PopupBody>
              <ValidationForm
                buttonsWrapper={PopupButtons}
                enableActionBtnByDefault={true}
                inputs={[
                  {
                    name: 'tagName',
                    label: 'Version name',
                    autoFocus: true,
                    maxLength: 50,
                    maxLengthMsg: `Max version length: 50 characters`,
                    value: this.getNextTagName(),
                    rules: [this.validateTagName],
                    applyOnEnter: true,
                  },
                ]}
                buttons={[
                  {
                    key: 'cancel',
                    label: 'Cancel',
                    action: this.cancel,
                    className: cancelButtonClass,
                  },
                  {
                    key: 'ok',
                    label: 'Save',
                    action: this.ok,
                    className: okButtonClass,
                  },
                ]}
              />
            </PopupBody>

            {previousVersions.length > 0 && (
              <div className="new-project-tag-form_previous-versions">
                <div className="new-project-tag-form_previous-versions_header">
                  Previous Versions
                </div>
                <div className="new-project-tag-form_previous-versions_list">
                  {previousVersions.map((tag) => {
                    return (
                      <div
                        key={tag.tagId}
                        className="new-project-tag-form_previous-versions_list_item"
                      >
                        <div
                          className="new-project-tag-form_previous-versions_list_item_message"
                          title={tag.message}
                        >
                          {tag.message}
                        </div>
                        <div className="new-project-tag-form_previous-versions_list_item_divider"></div>
                        <div className="new-project-tag-form_previous-versions_list_item_ts">
                          {moment(+tag.createTs).format(
                            formats.MM_DD_YYYY_hh_mm_a
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
            {tier !== 'free' && (
              <div className="new-project-tag-form_bottom-panel">
                <FilterSwitcher
                  labelIfTrue="Run on Testing"
                  labelIfFalse="Run on Testing"
                  offMode={true}
                  withBorder={true}
                  minWidth="initial"
                  maxWidth="initial"
                  onClick={this.onRunVersionOnTestingChange}
                  value={this.state.runVersionOnTestingFlag}
                />
                <FilterSwitcher
                  labelIfTrue="Run on Production"
                  labelIfFalse="Run on Production"
                  offMode={true}
                  withBorder={true}
                  minWidth="initial"
                  maxWidth="initial"
                  onClick={this.onRunVersionOnProductionChange}
                  value={this.state.runVersionOnProductionFlag}
                />
                <div
                  className="new-project-tag-form_bottom-panel_internal"
                  ref="runCopiedVersionOnProdTooltip"
                  data-place="right"
                  data-multiline="true"
                  data-effect="solid"
                  data-class="tutor-dark-tooltip run-copy-version-on-prod-tooltip"
                  data-for="runCopiedVersionOnProdTooltip"
                  data-tip="123"
                ></div>
              </div>
            )}
            {(device.isDesktop() && showTooltip) && (
              <ReactTooltip id="runCopiedVersionOnProdTooltip">
                <div>
                  Check if you want to run <br />
                  this version on the <br />
                  Production or Testing server.
                </div>
                <div
                  className="alan-tooltip-got-it"
                  onClick={this.rememberTooltipChoice}
                >
                  Got It
                </div>
              </ReactTooltip>
            )}
          </PopupWrapper>
        );
    }
}

export default withClickOutsideOnOverlay(NewProjectTagForm);